import * as React from 'react';

export const AndroidIcon: React.FC = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="18" height="22" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
      <title>27EF3987-9F28-4FBB-A5FB-5E9E94597713</title>
      <path
        d="M12.512 17.076v2.905a1.31 1.31 0 0 1-1.317 1.318 1.31 1.31 0 0 1-1.317-1.318v-2.905H8.122v2.905A1.31 1.31 0 0 1 6.805 21.3a1.31 1.31 0 0 1-1.317-1.318v-2.905h-.943c-.786 0-1.42-.579-1.42-1.297V8h11.75v7.779c0 .718-.634 1.297-1.42 1.297h-.943zM5.275 0c.068 0 .132.034.169.102l.96 1.777A6.254 6.254 0 0 1 9 1.32c.93 0 1.81.2 2.596.559l.96-1.777a.187.187 0 0 1 .26-.077.193.193 0 0 1 .074.267l-.948 1.758C13.766 3.024 14.998 4.875 15 7H3c.002-2.125 1.234-3.976 3.058-4.95L5.11.292a.193.193 0 0 1 .074-.267.183.183 0 0 1 .09-.025zm6.215 4a.494.494 0 0 0-.49.49c0 .268.222.49.49.49s.49-.222.49-.49a.494.494 0 0 0-.49-.49zm-5 0a.494.494 0 0 0-.49.49c0 .268.222.49.49.49s.49-.222.49-.49A.494.494 0 0 0 6.49 4zM1.051 8C.466 8 0 8.506 0 9.141v4.754c0 .636.466 1.141 1.051 1.141.586 0 1.052-.505 1.052-1.14V9.14C2.103 8.506 1.637 8 1.05 8zM16.95 8c-.586 0-1.052.506-1.052 1.141v4.754c0 .636.466 1.141 1.052 1.141.585 0 1.051-.505 1.051-1.14V9.14C18 8.506 17.534 8 16.949 8z"
        fill="currentColor"
        fillRule="evenodd"
        opacity=".9"
      />
    </svg>
  );
};
